import React from 'react'
import FeaturesSection from '../UAEPageComponents/FeaturesSection'
import { OtherFeaturesDataGrocery, OtherFeaturesDataRestaurants, UAEGroceryFeatures } from '../../../constants/common'
import HeaderSection from '../UAEPageComponents/HeaderSection'
import OtherFeatures from '../UAEPageComponents/OtherFeatures'
import OutletTypes from '../UAEPageComponents/OutletTypes'
import styles from '../../../styles/UAEPageComponents.module.css'
import NewFaqSection from '@/components/HomeLanding/HomeLandingComponents/NewFaqSection'
import BusinessUnlockSectionUAE from '@/components/HomeLanding/HomeLandingComponents/BusinessUnlockSectionUAE'
import ConnectWithUsUAE from '@/components/HomeLanding/HomeLandingComponents/ConnectWithUsUAE'
import AwardsSection from '@/components/HomeLanding/HomeLandingComponents/AwardsSection'
import UAEBlogsSection from '@/components/HomeLanding/HomeLandingComponents/UAEBlogsSection'
import ContqactSection from '../UAEPageComponents/ContactSection'

const DesktopGrocery = () => {
  const UAEGroceryHeader = {
    firstTitle: "POS Billing Software",
    secondTitle: "for Grocery Stores",
    description: <>
    <>A fast growing grocery store in UAE runs on everyday speed: peak hour rush, daily replenishment, and zero room for billing errors. QueueBuster is built for high-volume grocery stores where you need fast checkouts, tight stock control, and clear VAT-ready records, without complicated setups.</> <br /> <br />
    <>From single baqalas to multi-branch convenience stores, QueueBuster helps you bill faster, restock smarter, manage suppliers, track fast-moving items, and keep operations running even when connectivity drops. </>
    </>,
    images: {
      bgVector: "/assets/UAERetailPage/bgVector.svg",
      bgwidth: "42rem",
      bgheight: "40rem",
      bgtop: "17%",
      bgleft: "20%",
      bgbottom: "0%",
      bgright: "5%",
      bgzindex: "0",
      mainImage: {
        src: "/assets/uae-grocery/grocery_mainImg.webp",
        alt: "QueueBuster for Grocery",
        width: "41rem",
        height: "40rem",
        bottom: "0",
        right: "0"
      },
      img1: {
        src: "/assets/uae-grocery/Schedule.svg",
        alt: "Quick Bill",
        width: "17rem",
        height: "17rem",
        top: "12rem",
        left: "12%",
        zindex: 10
      },
      img2: {
        src: "/assets/uae-grocery/discount.svg",
        alt: "Schedule",
        width: "15rem",
        height: "5.5rem",
        bottom: "30%",
        left: "3%",
        zindex: 10
      },
      img3: {
        src: "/assets/uae-grocery/Frame.svg",
        alt: "Plane Image",
        width: "26rem",
        height: "16rem",
        top: "23%",
        right: "-8rem"
      }

    }
  }
  
  const OutletTypesData = [
    {
      image: "/assets/UAERetailPage/OutletTypesImg1.png",
      title: "Fashion & Apparel",
      hoverColor: "#F68E1E",
    },
    {
      image: "/assets/UAERetailPage/OutletTypesImg2.png",
      title: "Footwear",
      hoverColor: "#225590"
    },
    {
      image: "/assets/UAERetailPage/OutletTypesImg8.png",
      title: "Cosmetics",
      hoverColor: "#F68E1E",
    },
    {
      image: "/assets/UAERetailPage/OutletTypesImg3.png",
      title: "Accessories",
      hoverColor: "#225590"
    },
    {
      image: "/assets/UAERetailPage/OutletTypesImg4.png",
      title: "Home & Living",
      hoverColor: "#F68E1E",
    },
    {
      image: "/assets/UAERetailPage/OutletTypesImg5.png",
      title: "Carts & Kiosks",
      hoverColor: "#225590"
    },
    {
      image: "/assets/UAERetailPage/Restaurants.png",
      title: "Restaurants",
      hoverColor: "#F68E1E",
    },
    {
      image: "/assets/UAERetailPage/OutletTypesImg7.png",
      title: "Pet Store",
      hoverColor: "#225590"
    },

  ]

  const faqs = [
    {
      para: (
        <span style={{ width: "90%" }}>
          Why is QueueBuster a good fit for Grocery stores in the UAE?
        </span>
      ),
      des: "QueueBuster is built for fast grocery counters, supports VAT-ready billing, handles high SKU volumes, manages expiry tracking, and keeps purchasing and supplier records clean. The UAE grocery market moves fast, whether it's a neighbourhood baqala or a modern convenience chain, and QueueBuster is designed to keep up with that pace. From compliance-ready invoices to real-time stock visibility, it covers the everyday operational needs that grocery store owners in the UAE actually deal with.",
      id: 1,
      activeIndex: 1,
    },
    {
      para: (
        <span style={{ width: "90%" }}>
          Can it work for both small baqalas and multi-branch stores?
        </span>
      ),
      des: "Yes. QueueBuster scales from a single counter to multi-branch convenience chains with central reporting and stock sync. A small grocery store can get started quickly with minimal setup and run billing and inventory from day one. Larger operations benefit from consolidated dashboards, branch-wise performance tracking and centralised purchasing, all from one platform.",
      id: 2,
      activeIndex: 0,
    },
    {
      para: (
        <span style={{ width: "90%" }}>
          Does it support Arabic invoices?
        </span>
      ),
      des: "If you need bilingual invoices for your store workflow, QueueBuster can support English + Arabic invoice formats based on your configuration. This is especially useful for stores serving a predominantly Arabic-speaking customer base or working with local suppliers who prefer Arabic documentation. Having the right invoice format also helps with smoother record-keeping and faster dispute resolution with vendors.",
      id: 3,
      activeIndex: 0,
    },
    {
      para: (
        <span style={{ width: "90%" }}>
          Can it help reduce stockouts?
        </span>
      ),
      des: "Yes. Real-time stock updates and low-stock alerts help you reorder essentials before they run out. You can set custom reorder thresholds for your fastest-moving items so alerts trigger at the right time, not after you've already missed sales. Combined with purchase order tracking, you get a clear picture of what's been ordered, what's in transit and what needs urgent attention.",
      id: 4,
      activeIndex: 0,
    },
    {
      para: (
        <span style={{ width: "90%" }}>
          What about expiry and perishables?
        </span>
      ),
      des: "QueueBuster supports expiry tracking and alerts so you can manage near-expiry items better. You can track batches across perishable categories and get timely notifications before stock crosses its expiry window. This helps reduce wastage, avoid compliance issues and gives you the visibility needed to plan markdowns or supplier returns proactively.",
      id: 5,
      activeIndex: 0,
    },
    {
      para: (
        <span style={{ width: "90%" }}>
          Does it work without the internet?
        </span>
      ),
      des: "Yes. Offline billing keeps sales running and syncs data automatically once connectivity returns. This means your counter never goes down during a network outage, customers are billed without interruption and no transaction data is lost. For stores in areas with inconsistent connectivity, this reliability is a critical part of keeping daily operations running smoothly.",
      id: 6,
      activeIndex: 0,
    },

  ]

  return (
    <div style={{ fontFamily: 'GilroyMedium' }}>
      <HeaderSection data={UAEGroceryHeader} />

      <FeaturesSection
        data={UAEGroceryFeatures}
        title={"Smart Features for Fast-Moving Grocery stores"} />

      <OtherFeatures
        data={OtherFeaturesDataGrocery}
        title={<>More Features  <br />Grocery Store Owners Love</>} />

      {/* <OutletTypes title={"Grocery Outlet Types"} data={OutletTypesData} /> */}

      <div className={styles.resposiveSections}>
        <AwardsSection /> 
      <div ><BusinessUnlockSectionUAE /></div>
      <div><ConnectWithUsUAE /></div>
      </div>
      <div> <NewFaqSection FaqTableData={faqs} heading={"FAQs for UAE Grocery POS Software"}/>  </div>

      <div>
        <ContqactSection 
        title="Couldn’t Find What You Wanted?"
        description= {<>Send your inquiry and our UAE POS experts will guide you based on<br />
         your grocery store size, billing flow, and product mix.</>}
        buttonText="Request a callback"
      />
      </div>

      <div >
        <UAEBlogsSection />
      </div>
    </div>
  )
}






export default DesktopGrocery
